module.exports = __webpack_public_path__ + "img/thumbnail_HamadryasBaboon_m_normal.edb4ad68.png";